import { createClient } from '@supabase/supabase-js'
import { getRequiredRuntimeConfig } from './lib/runtimeConfig'

const { supabaseUrl, supabaseAnonKey } = getRequiredRuntimeConfig()

if (!supabaseUrl || !supabaseAnonKey) {
	console.error(
		'Supabase env not configured. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY for the deployed frontend.'
	)
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '')